import { requestInstance } from '@/helpers';
import { ENV } from '@/constants';

const ANONYMOUS_USER_URL = `${ENV.API_LIFT_STORY_URL}/anonymous-user`;
const USER_URL = `${ENV.API_LIFT_STORY_URL}/user`;

export const LandingAuthService = {
	async createAnonymousUser() {
		return await requestInstance(
			ANONYMOUS_USER_URL,
			{ source: 'web-app' },
			'post',
		);
	},
	async patchUser({ token, email }: { token: string; email: string }) {
		return await requestInstance(
			USER_URL,
			{ email },
			'patch',
			undefined,
			token,
		);
	},
};
